export default {
  LOGIN: 4,
  REGISTERED: 5,
  CONSENT_DIMENSION: 6,
  FORGOTTEN_PASSWORD: 7,
  RESET_PASSWORD: 8,
  USER_ID: 9,
  CUSTOM_DIMENSION: 23,
};
